// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleWorkflowState } from './moduleWorkflowState';
import type { ModuleStateInputStudentWorkflowState } from './moduleStateInputStudentWorkflowState';
import type { ModuleStateInputActiveForCurrentUser } from './moduleStateInputActiveForCurrentUser';
import type { ModuleStateInputEditAccessRequested } from './moduleStateInputEditAccessRequested';

/**
 * Publication, workflow etc. state of a module
 */
export interface ModuleStateInput {
  workflowState: ModuleWorkflowState;
  studentWorkflowState?: ModuleStateInputStudentWorkflowState;
  activeForCurrentUser?: ModuleStateInputActiveForCurrentUser;
  editAccessRequested?: ModuleStateInputEditAccessRequested;
}
